export const hfproFrameByFrame = () => {
    gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);
    function support_format_webp()
    {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d')))
        {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        else
        {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }

    document.addEventListener('DOMContentLoaded',()=> {
        document.querySelectorAll('.anchor').forEach(el=>{
            el.addEventListener('click',()=>{
                gsap.to(window, { duration: 1, scrollTo: el.dataset.target });
            })
        })

        var currentFrame;
        const canvas = document.getElementById("fbf");

        let progress = 0;
        let completed = 0;
        let format = 'jpg';
        const frameCount = 931;
        const context = canvas.getContext("2d");
        const images = [];
        const fbf = {
            frame: 0
        };

        if (support_format_webp()) {
            format = 'webp';
        }

        // create
        // let mm = gsap.matchMedia();

        // add a media query. When it matches, the associated function will run
        if (window.matchMedia('(min-width: 992px)').matches) {
            // mm.add("(min-width: 992px)", () => {

            canvas.width = 1920;
            canvas.height = 1080;
            currentFrame = index => (
                `/storage/Hfpro/video-frame-desktop/${format}/frame_${(index).toString().padStart(3, '0')}.${format}`
            );

            function render() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(images[fbf.frame], 0, 0);
            }

            for (let i = 0; i < frameCount; i++) {

                images.push('');
                loadImage(currentFrame(i))
                    .then(function (img) {

                        completed = completed +1;

                        var test = img.src.split('_');
                        var num = parseInt(test[1].split('.'));

                        images[num] = img;

                        progress = Math.round( completed / frameCount * 100 )

                        if (i == (frameCount-1)) {
                            //console.log('fine');
                            render();
                            setDesktopScene();
                            document.body.classList.add('ready');
                        }

                    })
                    .catch(function () {
                        console.error('Image failed to load :(');
                    });

            }

            function setDesktopScene() {
                let sectionHeight = window.innerHeight;
                let sectionNumber = 8;

                ScrollTrigger.create({
                    trigger: ".fbf-section__wrap",
                    start: 'top top',
                    end: "top+="+sectionHeight*(sectionNumber+1),
                    markers: false,
                    pin: true,
                });

                //STEP 1
                gsap.to(fbf, {
                    frame: 280,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top top',
                        end: "+="+sectionHeight,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 1
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top-='+sectionHeight+' top',
                    end: "+="+sectionHeight * 1.2,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--1').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--1').classList.remove('active');
                        }
                    },
                });

                //STEP 2
                gsap.to(fbf, {
                    frame: 380,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight+' top',
                        end: "+="+sectionHeight*2,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 2
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--2').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--2').classList.remove('active');
                        }
                    },
                });

                //STEP 3
                gsap.to(fbf, {
                    frame: 485,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*3+' top',
                        end: "+="+sectionHeight,
                        //markers: true,

                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 3
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*3+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--3').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--3').classList.remove('active');
                        }
                    },
                });

                //STEP 4
                gsap.to(fbf, {
                    frame: 586,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*4+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 4
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*4+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--4').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--4').classList.remove('active');
                        }
                    },
                });

                //STEP 5
                gsap.to(fbf, {
                    frame: 680,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*5+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 5
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*5+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--5').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--5').classList.remove('active');
                        }
                    },
                });

                //STEP 6
                gsap.to(fbf, {
                    frame: 790,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*6+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 6
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*6+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--6').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--6').classList.remove('active');
                        }
                    },
                });

                //STEP 7
                gsap.to(fbf, {
                    frame: 930,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*7+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 7
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*7+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--7').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--7').classList.remove('active');
                        }
                    },
                });

                //STEP 8
                /*gsap.to(fbf, {
                    frame: 790,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*8+' top',
                        end: "+="+sectionHeight * 0.5,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 8
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*8.25+' top',
                    end: "+="+sectionHeight,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--8').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--8').classList.remove('active');
                        }
                    },
                });*/
            }


            // });
        }
        if (window.matchMedia('(max-width: 991.98px)').matches) {
            // mm.add("(max-width: 991.98px)", () => {
            canvas.width = 1080;
            canvas.height = 1920;
            currentFrame = index => (
                `/storage/Hfpro/video-frame-mobile/${format}/frame_${(index).toString().padStart(3, '0')}.${format}`
            );

            function render() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(images[fbf.frame], 0, 0);
            }

            for (let i = 0; i < frameCount; i++) {

                images.push('');
                loadImage(currentFrame(i))
                    .then(function (img) {

                        completed = completed +1;

                        var test = img.src.split('_');
                        var num = parseInt(test[1].split('.'));

                        images[num] = img;

                        progress = Math.round( completed / frameCount * 100 )

                        if (i == (frameCount-1)) {
                            //console.log('fine');
                            render();
                            setMobileScene();
                            document.body.classList.add('ready');
                        }

                    })
                    .catch(function () {
                        console.error('Image failed to load :(');
                    });

            }

            function setMobileScene() {
                let sectionHeight = window.innerHeight;
                let sectionNumber = 8;

                ScrollTrigger.create({
                    trigger: ".fbf-section__wrap",
                    start: "top top",
                    end: "top+="+sectionHeight*(sectionNumber+1),
                    pin: true,
                    markers: false,
                });

                //STEP 1 MOBILE
                gsap.to(fbf, {
                    frame: 280,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top top',
                        end: "+="+sectionHeight,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 1 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top-='+sectionHeight+' top',
                    end: "+="+sectionHeight,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--1').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--1').classList.remove('active');
                        }
                    },
                });

                //STEP 2 MOBILE
                gsap.to(fbf, {
                    frame: 340,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight+' top',
                        end: "+="+sectionHeight*2,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 2 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--2').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--2').classList.remove('active');
                        }
                    },
                });

                //STEP 3 MOBILE
                gsap.to(fbf, {
                    frame: 455,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*3+' top',
                        end: "+="+sectionHeight,
                        //markers: true,

                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 3 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*3.25+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--3').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--3').classList.remove('active');
                        }
                    },
                });

                //STEP 4 MOBILE
                gsap.to(fbf, {
                    frame: 556,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*4+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 4 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*4+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--4').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--4').classList.remove('active');
                        }
                    },
                });

                //STEP 5 MOBILE
                gsap.to(fbf, {
                    frame: 680,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*5+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 5 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*5+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--5').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--5').classList.remove('active');
                        }
                    },
                });

                //STEP 6 MOBILE
                gsap.to(fbf, {
                    frame: 790,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*6+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 6 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*6+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--6').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--6').classList.remove('active');
                        }
                    },
                });

                //STEP 7 MOBILE
                gsap.to(fbf, {
                    frame: 930,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*7+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 7 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*7+' top',
                    end: "+="+sectionHeight * 0.6,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--7').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--7').classList.remove('active');
                        }
                    },
                });

                //STEP 8 MOBILE
                /*gsap.to(fbf, {
                    frame: 822,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.fbf-section',
                        start: 'top+='+sectionHeight*8+' top',
                        end: "+="+sectionHeight,
                        //markers: true,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                //SLIDE 8 MOBILE
                ScrollTrigger.create({
                    trigger: '.fbf-section',
                    start: 'top+='+sectionHeight*8.25+' top',
                    end: "+="+sectionHeight,
                    onToggle: self => {
                        if (self.isActive) {
                            document.querySelector('.fbf-section__slide--8').classList.add('active');
                        } else {
                            document.querySelector('.fbf-section__slide--8').classList.remove('active');
                        }
                    },
                });*/
            }

            // });
        }
    });
}
